export default __webpack_public_path__ + "static/media/003-dwarf.968496e2.svg";